var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6874718,11.761581 L21.7667318,2.80965436 C22.0777561,2.50299215 22.0777561,2.00711284 21.7667318,1.70045063 L21.2042412,1.14584876 C20.893217,0.839186552 20.3902843,0.839186552 20.07926,1.14584876 L11,10.0977754 L1.92073996,1.15237349 C1.60971575,0.845711279 1.10678297,0.845711279 0.795758761,1.15237349 L0.233268161,1.70697535 C-0.0777560535,2.01363756 -0.0777560535,2.50951688 0.233268161,2.81617909 L9.3125282,11.761581 L0.239885697,20.7135076 C-0.0711385171,21.0201698 -0.0711385171,21.5160491 0.239885697,21.8227113 L0.802376297,22.3773132 C1.11340051,22.6839754 1.61633328,22.6839754 1.9273575,22.3773132 L11,13.4253866 L20.07926,22.3773132 C20.3902843,22.6839754 20.893217,22.6839754 21.2042412,22.3773132 L21.7667318,21.8227113 C22.0777561,21.5160491 22.0777561,21.0201698 21.7667318,20.7135076 L12.6874718,11.761581 Z",
    fill: "#323A45",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/Icon_Close.bf3d9c10.svg";
export { ForwardRef as ReactComponent };